export default __webpack_public_path__ + "static/media/le_lion3.c9b68456.jpg";